import { SiteUtilities } from './utils';

const prefillForm = (section, name, value) => {
  if (!section || !name || !value) return;
  const element = section.find('input[name=' + name + ']');
  element.val(value);
  return $(element).valid();
};

const initForm = (id) => {
  const section = $($('[data-form-section=' + id + ']')[0]);
  const shopifyJwt = SiteUtilities.getParameterByName('shopify_jwt');
  const currentUrl = new URL(window.location.href);
  const urlHasShopifyParam = (currentUrl.searchParams.get('shopify_jwt') || (currentUrl.searchParams.get('shopify_jwt') === ''));
  const errorRedirectUrl = section.find('form').data('marketplace-error-redirect-url') || '/';
  let userDetails;
  if (shopifyJwt) {
    try {
      const associatedUser = JSON.parse(atob(shopifyJwt.split('.')[1])).associated_user;
      userDetails = {
        'first-name': associatedUser.first_name,
        'last-name': associatedUser.last_name,
        email: associatedUser.email
      };
    } catch (e) {
      if (!urlHasShopifyParam) {
        window.location.href = errorRedirectUrl;
      }
    }
  } else {
    if (!urlHasShopifyParam) {
      window.location.href = errorRedirectUrl;
    }
  }
  for (const item in userDetails) {
    if (!prefillForm(section, item, userDetails[item])) return;
  }
  if (userDetails.email) {
    const embedUserInfo = section.find('.embed-user-info');
    $(embedUserInfo.find('.data-label')[0]).text(userDetails.email);
    $(embedUserInfo).removeClass('hide').attr('aria-hidden', 'false');
  }
};

const signupReferrerDefault = (id) => {
  const attReferrer = SiteUtilities.getParameterByName('att_referrer') || 'others';
  localStorage.setItem('att_referrer', attReferrer);
  if (attReferrer.includes('shopify')) {
    const section = $($('[data-form-section=' + id + ']')[0]);
    section.find('[data-signup-product]').hide();
  }
  const tacticId = SiteUtilities.getTacticID();
  if (tacticId === '5034626') {
    sessionStorage.removeItem('tactic_id');
    SiteUtilities.setTacticID();
  }
};

const signupReferrerUpdate = () => {
  const existingReferrer = localStorage.getItem('att_referrer');
  if (!existingReferrer) {
    localStorage.setItem('att_referrer', 'shopifydirect');
    sessionStorage.setItem('tactic_id', '5034626');
  }
};

export default { initForm, signupReferrerDefault, signupReferrerUpdate };
